<div mat-dialog-title class="title">Anexos</div>
<mat-dialog-content>
  <div class="header">
    <div class="status">
      {{ data.length | i18nPlural: statusMapping }}
    </div>
    <button
      class="clear-button"
      tabindex="-1"
      mat-button
      (click)="clear()"
      [disabled]="data.length == 0"
    >
      Limpar todos
    </button>
  </div>
  <mat-list>
    <mat-list-item class="file-item" *ngFor="let file of data">
      <div class="file-details">
        <img
          matListAvatar
          [src]="isImage(file) ? imageIcon : pdfIcon"
          class="file-avatar"
        />
        <div class="file-info">
          <div class="file-name">{{ file.name }}</div>
          <span>{{ file.size | fileSize }}</span>
        </div>
      </div>
      <button mat-icon-button tabindex="-1" (click)="remove(file)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
  <div class="action-footer">
    <button tabindex="-1" mat-button (click)="hiddenfileinput.click()">
      <mat-icon>attach_file</mat-icon>
      {{ data.length | i18nPlural: addItemsText }}
    </button>
    <input
      #hiddenfileinput
      type="file"
      accept="image/*, .pdf"
      id="upload"
      hidden
      (change)="add($event)"
      multiple
    />
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close tabindex="-1" class="bt-cancel">
    Cancelar
  </button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-raised-button [mat-dialog-close]="data" class="bt-ok">
    Enviar
  </button>
</mat-dialog-actions>
